import { ACTIVATETEMPLATE_SUCCESS, ACTIVATETEMPLATE_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const activateTemplateReducer = (state = initialState, action) => {
    switch (action.type) {
        case ACTIVATETEMPLATE_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case ACTIVATETEMPLATE_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default activateTemplateReducer;
